import { FC } from "react";
import { Box, Flex } from "@chakra-ui/react";

import MachineReasoningLoadingIcon from "@assets/files/images/icons/machineReasoningLoadingIcon.svg?react";

const MachineReasoningLoading: FC = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" width="100%" height="80%">
      <MachineReasoningLoadingIcon />
      <Flex alignItems="flex-end">
        <Box textStyle="noMatchesTitle" mt="17px" fontSize="26px" color="blue.900">
          Analysis is in progress
        </Box>
      </Flex>
      <Box textStyle="noMatchesSubtitle" mt="17px" w="220px" textAlign="center">
        Please wait while we’re preparing Machine reasoning
      </Box>
    </Box>
  );
};

export default MachineReasoningLoading;
